export default __webpack_public_path__ + "static/media/mq.c1adad84.svg";